"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";
import { getAssetUrl } from "@/utils/assetUrl";

export default function SocialProofSection() {
  const t = useTranslations("results-page.social-proof-section");

  return (
    <section className="social-proof-section">
      <Image
        className="social-proof-section-rise"
        src={getAssetUrl("/images/results/resmed_rise.svg")}
        alt=""
        width={2251}
        height={649}
        aria-hidden="true"
        unoptimized
      />
      <div className="social-proof-section-card">
        {/* Left: Picture frame */}
        <div className="social-proof-section-picture-frame">
          <div className="social-proof-section-image-container">
            <Image
              src={getAssetUrl("/images/results/social_proof.webp")}
              alt={t("image-alt")}
              className="social-proof-section-image"
              width={360}
              height={496}
              unoptimized
            />
            <span className="social-proof-section-chip social-proof-section-chip--top">
              {t("chip-top")}
            </span>
            <span className="social-proof-section-chip social-proof-section-chip--bottom">
              {t("chip-bottom")}
            </span>
          </div>
        </div>

        {/* Right: Text frame */}
        <div className="social-proof-section-text-frame">
          <div className="social-proof-section-content">
            <h2 className="headline social-proof-section-headline">
              {t.rich("headline", {
                gradient: (chunks) => (
                  <span className="social-proof-section-headline-gradient">
                    {chunks}
                  </span>
                ),
              })}
            </h2>

            <div className="social-proof-section-testimonial-card">
              <p className="social-proof-section-testimonial-text">
                {t("testimonial")}
              </p>
              <p className="social-proof-section-testimonial-attribution">
                {t("attribution")}
              </p>
            </div>

            <p className="social-proof-section-disclaimer">{t("disclaimer")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
